<template>
	<!-- 收料信息-->
	<div class="saleCustomerManagement">
		<div class="public_Spacing customerManagementPC">
			<div class="pulbic_oparetionBlock">
				<div class="public_criteriaRange customerManagementPC-select">
					<div class="public_oparetionBlock_Menu">
						<label class="public_lbSty">发单人：</label>
						<!-- <el-select class="public_optionSty dropDown_Define" v-model="senderId" placeholder="请选择"
							:clearable="true" filterable @change="getName">
							<el-option v-for="item in customerOptions" :key="item.ORMTB410ID" :label="item.ORMTB410CA00"
								:value="item.ORMTB410ID">
							</el-option>
						</el-select> -->
						<EnhancedSelect v-model="senderId" :options="customerOptions" label-key="ORMTB410CA00"
							value-key="ORMTB410ID" pinyin-key="ORMTB410CA13" @change="getName" :enable-pinyin-search="true"
							:enable-first-letter-search="true" />
					</div>
					<div class="public_oparetionBlock_Menu">
						<label class="public_lbSty">手机号：</label>
						<div class="el-select public_optionSty">
							<div class="el-input el-input--suffix">
								<el-input maxlength="11" type="text" placeholder="请输入手机号" v-model="cusQueryiphone"
									:clearable="true"></el-input>
							</div>
						</div>
					</div>
				</div>
				<div class="public_oparetionBlock_Menu"
					style="display: flex;justify-content: flex-end;margin-bottom: 10px;">
					<el-button class="public_saleWater_fabu" type="primary" @click="releaseInfo">发布</el-button>
					<el-button class="public_saleWater_chaxun" type="primary" v-shiroHiden="solelist" id="查询"
						@click="querycusList">查询</el-button>
					<el-button class="public_saleWater_chaxun" type="primary"
						style="background-color: #20DA9C!important;border-color: transparent;"
						@click="reset">重置</el-button>
				</div>
			</div>
			<div class="billOperationRecord-table pulbic_table_container">
				<el-table :data="tableData" @sort-change="onSortChange" style="width: 100%" stripe
					class="public_tableColumn"
					:header-cell-style="{ color: 'rgba(51,51,51,1)', background: 'rgba(184,227,255,1)', 'font-weight': 'bold' }">
					<el-table-column prop="ORMTB493CA11" fixed="left" width="110" label="发布时间"></el-table-column>
					<el-table-column prop="ORMTB410CA01" fixed="left" label="发布人">

						<!-- <template slot-scope="scope">
							<p>
								<span>{{ scope.row.ORMTB410CA00 }}</span>
							</p>
							<p style="color: #999;">
								<span>{{ scope.row.ORMTB493CA15 }}</span>
							</p>

						</template> -->

					</el-table-column>
					<!-- <el-table-column prop="ORMTB460CA15" label="手机号">
					</el-table-column> -->
					<!-- <el-table-column prop="ORMTB410CA02" label="手机号"></el-table-column> -->
					<el-table-column prop="ORMTB493CA04" label="厂家"></el-table-column>
					<el-table-column prop="ORMTB493CA21" label="站点"></el-table-column>
					<el-table-column prop="ORMTB493CA02" label="车型">
					</el-table-column>
					<!-- <el-table-column prop="ORMTB460CA04" label="厂家"></el-table-column> -->
					<el-table-column prop="ORMTB493CA06" label="物料"></el-table-column>
					<el-table-column prop="ORMTB493CA07" label="收料单价"></el-table-column>
					<el-table-column prop="ORMTB493CA10" label="吨数"></el-table-column>
					<el-table-column prop="ORMTB493CA25" label="亏吨范围(吨)"></el-table-column>
					<!-- <el-table-column prop="ORMTB460CA27" label="超时取消时间(小时)"></el-table-column> -->
					<!-- <el-table-column prop="ORMTB460CA08" fixed="right" label="总车数"></el-table-column>
					<el-table-column prop="ORMTB450CA15" fixed="right" label="已接车数">
						<template slot-scope="scope">
							<span>{{parseInt(scope.row.ORMTB460CA08)-parseInt(scope.row.ORMTB460CA10)}}</span>
						</template>
					</el-table-column> -->

					<!-- <el-table-column prop="ORMTB460CA10" fixed="right" label="未接车数"></el-table-column> -->
					<el-table-column v-if="userobj.pertb005.pertb005cb00 == 'CUS-1'" prop="ORMTB493CA33" fixed="right"
						label="运单类型">
						<template slot-scope="scope">
							<span v-if="scope.row.ORMTB493CA33 == '0'">自发</span>
							<span v-if="scope.row.ORMTB493CA33 == '1'">代发</span>
						</template>
					</el-table-column>
					<el-table-column label="操作" fixed="right" width="200">
						<template slot-scope="scope">
							<div class="customerManagementPC-table-btn">
								<!-- <el-button v-if="scope.row.ORMTB493CA13 == '-1'" @click="updateUserStatus(scope.row)"
									type="success" style="color: #67C23A!important"
									class="public_icon_xiugai public_icon_width" size="small">通过
								</el-button> -->
								<el-button v-if="scope.row.ORMTB493CA13 == 0" @click="handleStopReceive(scope.row)"
									type="success" style="color: #FE6001!important"
									class="public_icon_xiugai public_icon_width" size="small" v-shiroHiden="solelist"
									id="开始收料">开始收料
								</el-button>
								<el-button v-if="scope.row.ORMTB493CA13 == 1" v-shiroHiden="solelist" id="停止收料"
									@click="handleStopReceive(scope.row)" type="success"
									style="color: #FE6001!important" class="public_icon_xiugai public_icon_width"
									size="small">停止收料
								</el-button>
								<el-button v-if="scope.row.ORMTB493CA13 == 0 || scope.row.ORMTB493CA13 == 1"
									@click="handleFinshReceive(scope.row)" type="success"
									style="color: #20DA9C!important" class="public_icon_xiugai public_icon_width"
									size="small" v-shiroHiden="solelist" id="完成收料">完成收料
								</el-button>
								<el-button v-if="scope.row.ORMTB493CA13 == -1" @click="handleShow(scope.row)"
									type="success" style="color: #20DA9C!important"
									class="public_icon_xiugai public_icon_width" size="small" v-shiroHiden="solelist"
									id="审核">审核
								</el-button>
								<el-button v-if="scope.row.ORMTB493CA13 == -1" @click="handleRefuse(scope.row)"
									type="success" style="color: #FF0000!important"
									class="public_icon_xiugai public_icon_width" size="small" v-shiroHiden="solelist"
									id="拒绝">拒绝
								</el-button>
								<el-button
									v-if="scope.row.ORMTB493CA13 == 0 || scope.row.ORMTB493CA13 == 1 || scope.row.ORMTB493CA13 == 2"
									@click="handleOrder(scope.row)" type="success" style="color: #FF0000!important"
									class="public_icon_xiugai public_icon_width" size="small" v-shiroHiden="solelist"
									id="接单状态">接单状态
								</el-button>
								<el-button v-if="scope.row.ORMTB493CA13 == 0 || scope.row.ORMTB493CA13 == 1"
									@click="handleEdit(scope.row)" type="success" style="color: #2029DA!important"
									class="public_icon_xiugai public_icon_width" size="small" v-shiroHiden="solelist"
									id="修改">修改
								</el-button>
								<el-button
									v-if="scope.row.ORMTB493CA13 == 0 || scope.row.ORMTB493CA13 == 1 || scope.row.ORMTB493CA13 == 2 || scope.row.ORMTB493CA13 == 3"
									@click="DetailsClick(scope.row)" type="primary"
									class="public_icon_xiugai public_icon_width" size="small"
									style="color: #409EFF!important" v-shiroHiden="solelist" id="详情">详情</el-button>
							</div>
						</template>
					</el-table-column>
				</el-table>
				<div class="customerManagementPC-page">
					<span style="font-size: 14px;color:#606266;" v-if="flag == '1'">共{{ count }}条</span>
					<el-pagination v-if="!flag" @size-change="handleSizeChange" @current-change="handleCurrentChange"
						:current-page.sync="currentPage" :page-sizes="[10, 20, 30, 40]"
						layout="total, sizes,prev, pager, next" :page-size="pagesize" :total="count"></el-pagination>
				</div>
			</div>
			<!-- 发布 -->
			<add-info v-if="showDialogAdd" :visible.sync="showDialogAdd" @addSubmit="handleAddSubmit"></add-info>
			<!-- 审核 -->
			<audit-info-dialog v-if="showDialog" :ORMTB493CA03="ORMTB493CA03" :ORMTB493CA05="ORMTB493CA05"
				:ORMTBSL410ID="ORMTBSL410ID" :ORMTB493CA20="ORMTB493CA20" :ORMTB493CA21="ORMTB493CA21"
				:ORMTB493CA22="ORMTB493CA22" :ORMTB493CA23="ORMTB493CA23" :ORMTB493CA07="ORMTB493CA07"
				:visible.sync="showDialog" @submit="handleSubmit" />
			<!-- 接单状态 -->
			<order-list :visible.sync="showDialogOrder" :id="ORMTB493ID"></order-list>
			<!-- 详情 -->
			<detail-info :visible.sync="showDialogDetail" :id="ORMTB493ID"></detail-info>
			<!-- 修改 -->
			<edit-info v-if="showDialogEdit" :visible.sync="showDialogEdit" :id="ORMTB493ID"
				@editSubmit="handleSubmitEdit"></edit-info>
		</div>
	</div>
</template>

<script>
import Detail from '../serviceStation/saleRate/detail'
import {
	Decimal
} from 'decimal.js';
import AuditInfoDialog from './components/AuditInfoDialog.vue';
import OrderList from './components/OrderList.vue';
import DetailInfo from './components/DetailInfo.vue';
import EditInfo from './components/EditInfo.vue';
import AddInfo from './components/AddInfo.vue';
import EnhancedSelect from './components/EnhancedSelect.vue';
export default {
	components: {
		Detail,
		AuditInfoDialog,
		OrderList,
		DetailInfo,
		EditInfo,
		AddInfo,
		EnhancedSelect
	},
	data() {
		return {
			customerManagementList: '',
			customerManagementValue: '',
			customerManagement: false,
			customerManagementAdd: false,
			customerManagementAddName: '',
			customerManagemenUPObj: '',
			customerManagementUpdate: false,
			oerderDetilsShow: false,
			shMasgObj: {},
			cusQueryNameFD: '',
			cusQueryiphone: '',
			options: [],
			cusStatus: '',
			cusStatusList: [],
			tableData: [],
			flag: '',
			page: 1,
			pagesize: 10,
			currentPage: 1,
			count: 0,
			currentPage1: 1,
			detailsPageLimit: 10,
			detailsCount: 1,
			RechargetypeValue: '',
			RechargetypeOptions: [],
			CZRecordsDetails: [],
			CZRecordsPage: 1,
			CZRecordsPageLimit: 10,
			CZRecordsCount: 0,
			tableDataDetails: [],
			offerDetailsTab: [],
			ORMTB411ID: '',
			CustomerfillingDig: false,

			CZmoney: '',
			Czmaxlength: 10, //充值限额
			HCmoney: '',
			HCremark: '',
			HCamountCapitalText: '',
			amountCapitalText: '',
			cusInsertShow: false,
			cusInsertObj: {
				ORMTB400ID: '',
				ORMTB410CA00: '',
				ORMTB410CA01: '',
				ORMTB410CA02: '',
				ORMTB410CA06: ''
			},
			cusUpdateShow: false,
			cusUpdateObj: {
				ORMTB400ID: '',
				ORMTB410CA00: '',
				ORMTB410CA01: '',
				ORMTB410CA02: '',
				ORMTB410CA06: ''
			},
			saleWaterDetails: false,
			rechargeTypeDig: false,
			rechargeTypeName: '',
			rechargeTypeUpOBJ: {
				SETTB206CA01: ''
			},
			rechargeTypeModifyDig: false,
			czRechargetypeShow: false,
			HCshow: false,
			HCObj: '',
			preferentialRecord: false,
			offerDetails: false,
			DetailsWater: false,
			deductionRecord: false,
			deductionRecordObj: '',
			deductionRecordtable: [],
			deductionRecordPage: 1,
			deductionRecordLimit: 10,
			deductionRecordCount: 0,
			showDialogDetail: false,
			preferentialType: 0,
			solelist: [],
			xsZsrcList: [],
			xsFsrcList: [],
			jszsrcList: [],
			showDialog: false,
			showDialogOrder: false,
			senderId: '',//发单人id
			customerOptions: [
				{
					ORMTB410ID: '',
					ORMTB410CA00: '全部',
				},
			],
			userobj: {},
			ORMTB493CA13: 1,//去开启
			ORMTB493ID: '',//订单id
			showDialogEdit: false,
			ORMTB493CA05: '',//物料ID
			ORMTB493CA03: '',//厂家ID
			ORMTBSL410ID: '',
			ORMTB493CA20: '',
			ORMTB493CA21: '',
			ORMTB493CA22: '',
			ORMTB493CA23: '',
			ORMTB493CA07: '',
			showDialogAdd: false,
		};
	},
	created() {
		var list = "";
		if (this.$route.query.mark != "" && this.$route.query.mark != null) {
			this.userobj = JSON.parse(sessionStorage.getItem("qpUobj"));
			list = JSON.parse(sessionStorage.getItem("qpSolelist"));
			sessionStorage.removeItem('qpUobj');
			sessionStorage.removeItem('qpSolelist');
			this.quanpDisabled = true;
		} else {
			this.userobj = this.$store.state.uobj;
			console.log(this.userobj)
			list = this.$store.state.solelist;
			this.quanpDisabled = false;
		}
		var path = this.$route.path;
		if (path === "/salesslMaseg") {
			path = "/Home" + path;
		}
		this.solelist = this.$baseAPI.querSoleList(list, path); //获取权限列表
		// // 赋值，缓存销毁
		this.historyInfo = JSON.parse(sessionStorage.getItem(this.currentUrl));
		sessionStorage.removeItem(this.currentUrl);
		if (this.historyInfo != null && this.historyInfo != "") {
			this.init();
		}
		// console.log(this.solelist)
	},
	mounted() {
		this.enterprise0ptions();
		this.querycusList()
		// this.querypreferentialCode()
	},
	// 存储数据
	beforeDestroy() {
		// var obj = {
		// 	cusQueryNameFD: this.cusQueryNameFD, //客户名称
		// 	cusQueryiphone: this.cusQueryiphone, //客户手机号
		// 	cusStatus: this.cusStatus, //客户状态
		// 	currentPage: this.currentPage, //当前页数
		// 	page: this.page, //页码
		// 	pagesize: this.pagesize, //每页条数
		// };
		// sessionStorage.setItem(this.currentUrl, JSON.stringify(obj));
	},
	methods: {
		releaseInfo() {
			this.showDialogAdd = true;
		},
		handleSubmitEdit(formData) {
			this.axios.post('/orm/ormtb493/update493', { ...formData, ORMTB493ID: this.ORMTB493ID }).then(res => {
				if (res.data.code == 200) {
					this.$message({
						message: res.data.message,
						type: 'success',
					})
					this.showDialogEdit = false;
					this.querycusList();
				} else {
					formData.ORMTB493CA34 = formData.ORMTB493CA34 ? (formData.ORMTB493CA34 * 100) : 0;
					formData.ORMTB493CA37 = formData.ORMTB493CA37 ? this.convertApiDateToRange(formData.ORMTB493CA37) : '';
					this.$message({
						message: res.data.message,
						type: 'error',
					})
				}
			})
		},
		handleEdit(row) {
			this.ORMTB493ID = row.ORMTB493ID;
			this.showDialogEdit = true;
		},
		handleStopReceive(row) {//开启、停止收料
			this.ORMTB493CA13 = row.ORMTB493CA13 == 1 ? 0 : 1;
			this.$confirm(`确定要${row.ORMTB493CA13 == 1 ? '停止' : '开始'}收料吗?`, '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				this.axios.post('/orm/ormtb493/changeStatusOrmtb493', { ORMTB493ID: row.ORMTB493ID, ORMTB493CA13: this.ORMTB493CA13 }).then(res => {
					if (res.data.code == 200) {
						this.$message({
							message: res.data.message,
							type: 'success',
						})
						this.querycusList();
					} else {
						this.$message({
							message: res.data.message,
							type: 'error',
						})
					}
				})
			})
		},
		handleFinshReceive(row) {//完成收料
			this.$confirm('确定要完成收料吗?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				this.axios.post('/orm/ormtb493/finishOrmtb493', { ORMTB493ID: row.ORMTB493ID }).then(res => {
					if (res.data.code == 200) {
						this.$message({
							message: res.data.message,
							type: 'success',
						})
						this.querycusList();
					} else {
						this.$message({
							message: res.data.message,
							type: 'error',
						})
					}
				})
			}).catch(() => {

			});

		},
		reset() {
			this.senderId = '';
			this.cusQueryNameFD = '';
			this.cusQueryiphone = '';
			this.currentPage = 1;
			this.page = 1;
			this.querycusList();
		},
		getName(e) {
			const selectedOption = this.customerOptions.find(item => item.ORMTB410ID === e);
			if (selectedOption) {
				const label = selectedOption.ORMTB410CA00;
				this.cusQueryNameFD = label;
			}
		},
		// 客户--查询
		enterprise0ptions() {
			var postData = {}
			if (this.userobj.pertb005.pertb005cb00 == 'CUS-2') {
				postData = {
					ORMTB400ID: this.userobj.ormtb410.ORMTB410ID, //一级企业id
				}
			}
			if (this.userobj.pertb005.pertb005cb00 == 'CUS-1') {
				postData = {
					ORMTB400ID: this.userobj.ormtb400.ORMTB400ID, //一级企业id
				}
			}

			var List = [
				{
					ORMTB410ID: '',
					ORMTB410CA00: '全部',
				},
			]
			var url = '/orm/ormtb410/selectOrmtb410s'
			this.axios.post(url, postData).then(res => {
				console.log(res)

				if (res.data.code == 200) {
					// 客户
					this.customerOptions = [...List, ...res.data.data]
				} else {
					this.$message({
						message: res.data.message,
						type: 'error',
					})
				}
			})
		},
		handleOrder(row) {
			this.ORMTB493ID = row.ORMTB493ID;
			this.showDialogOrder = true;
		},
		// 拒绝操作
		handleRefuse(row) {
			this.$prompt(
				`<div style="text-align: center;">
     <i class="el-icon-warning" style="color: #FF0200; font-size: 60px; margin-bottom: 10px; display: block;"></i>
	 <div style="font-size: 19px; font-weight: bold;margin-bottom: 13px">提示</div>
     请确认是否拒绝该订单？
   </div>`,
				'',
				{
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					inputPlaceholder: '请输入拒绝原因',
					dangerouslyUseHTMLString: true,  // 允许 HTML
					customClass: 'custom-prompt',    // 自定义样式类（可选）
					center: true                    // 让弹框整体居中（Element UI 支持）
				}
			).then(({ value }) => {
				this.axios.post('/orm/ormtb493/rejectOrmtb493', { ORMTB493ID: row.ORMTB493ID, ORMTB493CA72: value }).then(res => {
					if (res.data.code == 200) {
						this.$message({
							message: res.data.message,
							type: 'success',
						})
						this.querycusList();
					} else {
						this.$message({
							message: res.data.message,
							type: 'error',
						})
					}
				})
			}).catch(() => { });
		},
		handleShow(row) {
			this.ORMTB493ID = row.ORMTB493ID;
			this.ORMTB493CA03 = row.ORMTB493CA03;
			this.ORMTB493CA05 = row.ORMTB493CA05;
			this.ORMTBSL410ID = row.ORMTBSL410ID;
			this.ORMTB493CA20 = row.ORMTB493CA20;
			this.ORMTB493CA21 = row.ORMTB493CA21;
			this.ORMTB493CA22 = row.ORMTB493CA22;
			this.ORMTB493CA23 = row.ORMTB493CA23;
			this.ORMTB493CA07 = row.ORMTB493CA07;
			this.showDialog = true;
		},
		handleSubmit(formData) {
			this.axios.post('/orm/ormtb493/passOrmtb493', { ...formData, ORMTB493ID: this.ORMTB493ID }).then(res => {
				if (res.data.code == 200) {
					this.$message({
						message: res.data.message,
						type: 'success',
					})
					this.showDialog = false;
					this.querycusList();
				} else {
					formData.ORMTB493CA34 = formData.ORMTB493CA34 ? (formData.ORMTB493CA34 * 100) : 0;
					formData.ORMTB493CA37 = formData.ORMTB493CA37 ? this.convertApiDateToRange(formData.ORMTB493CA37) : '';
					this.$message({
						message: res.data.message,
						type: 'error',
					})
				}
			})
		},
		handleAddSubmit(formData) {
			this.axios.post('/orm/ormtb493/createOrmtb493', { ...formData }).then(res => {
				if (res.data.code == 200) {
					this.$message({
						message: res.data.message,
						type: 'success',
					})
					this.showDialogAdd = false;
					this.querycusList();
				} else {
					formData.ORMTB493CA34 = formData.ORMTB493CA34 ? (formData.ORMTB493CA34 * 100) : 0;
					formData.ORMTB493CA37 = formData.ORMTB493CA37 ? this.convertApiDateToRange(formData.ORMTB493CA37) : '';
					this.$message({
						message: res.data.message,
						type: 'error',
					})
				}
			})
		},
		convertApiDateToRange(apiDateString) {
			if (!apiDateString || !apiDateString.includes('~')) {
				return [];
			}
			return apiDateString.split('~');
		},
		onSortChange({
			prop,
			order
		}) {
			// console.log(order)
			if (prop == 'ORMTB410CA06') {
				this.tableData.sort(this.compare(prop, order));
			}

		},
		compare(propertyName, sort) {
			return function (obj1, obj2) {
				var value1 = obj1[propertyName];
				var value2 = obj2[propertyName];
				// console.log(value2)

				if (typeof value1 === "string" && typeof value2 === "string") {
					const res = value1.localeCompare(value2);
					return sort === "ascending" ? res : -res;
				} else {
					// if (value1 <= value2) {
					// 	return sort === "ascending" ? -1 : 1;
					// } else if (value1 > value2) {
					// 	return sort === "ascending" ? 1 : -1;
					// }
				}
			};
		},

		// 详情
		DetailsClick(row) {
			this.ORMTB493ID = row.ORMTB493ID;
			this.showDialogDetail = true;
		},

		//修改配送地址
		updateUserJJStatus(item) {
			// console.log(item)
			var url = "/orm/ormtb460/update"
			this.$prompt('请输入配送地', '配送地修改', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				inputPattern: /^.{1,}$/,
				inputValue: item.ORMTB460CA01,
				inputErrorMessage: '内容不能为空'
			}).then(({
				value
			}) => {
				var postData = {
					ORMTB460ID: item.ORMTB460ID,
					ORMTB460CA01: value
				}
				var loading = this.$loading({
					lock: true,
					text: '请求中...',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.5)'
				});
				this.axios.post(url, postData).then(res => {
					// console.log(res)
					if (res.data.code == 200) {
						this.$message({
							message: res.data.message,
							type: 'success'
						});
						this.querycusList()
					} else {
						this.$message({
							message: res.data.message,
							type: 'error'
						});
					}
					setTimeout(() => {
						loading.close()
					}, 300)
				}).catch(() => {
					loading.close()
				})
			})
		},

		//取消车数
		updateUserJJStatusQX(item) {
			// console.log(item)
			var url = "/orm/ormtb460/cancelORMTB460"
			this.$prompt('请输入需要取消的车数', '取消车数', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				inputPattern: /^.{1,}$/,
				// inputValue:item.ORMTB460CA01,
				inputErrorMessage: '内容不能为空'
			}).then(({
				value
			}) => {
				var postData = {
					ORMTB460ID: item.ORMTB460ID,
					COUNT: value
				}
				var loading = this.$loading({
					lock: true,
					text: '请求中...',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.5)'
				});
				this.axios.post(url, postData).then(res => {
					// console.log(res)
					if (res.data.code == 200) {
						this.$message({
							message: res.data.message,
							type: 'success'
						});
						this.querycusList()
					} else {
						this.$message({
							message: res.data.message,
							type: 'error'
						});
					}
					setTimeout(() => {
						loading.close()
					}, 300)
				}).catch(() => {
					loading.close()
				})
			})
		},


		updateUserJJYYStatus(item) {
			// console.log(item)
			var url = "/orm/ormtb450/updateORMTB450CA10"
			this.$alert(item.ORMTB450CA17, '拒绝原因', {
				confirmButtonText: '确定',
				callback: action => {

				}
			});
		},
		// 通过
		updateUserStatus(item) {
			var url = "/orm/ormtb493/passOrmtb493"

			// console.log(item)
			var postData = {
				ORMTB493ID: item.ORMTB493ID
			}
			var loading = this.$loading({
				lock: true,
				text: '请求中...',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.5)'
			});
			this.axios.post(url, postData).then(res => {
				// console.log(res)
				if (res.data.code == 200) {
					this.$message({
						message: res.data.message,
						type: 'error'
					});
					this.querycusList()
				} else {
					this.$message({
						message: res.data.message,
						type: 'error'
					});
				}
				setTimeout(() => {
					loading.close()
				}, 300)
			}).catch(() => {
				loading.close()
			})

		},



		//初始化数据
		init() {
			// this.cusQueryNameFD = this.historyInfo.cusQueryNameFD;
			// this.cusQueryiphone = this.historyInfo.cusQueryiphone;
			this.currentPage = this.historyInfo.currentPage;
			this.page = this.historyInfo.page;
			this.pagesize = this.historyInfo.pagesize;
			this.cusStatus = this.historyInfo.cusStatus
		},
		fullScreen() {
			//全屏
			var mark = 1;
			sessionStorage.setItem(
				"qpSolelist",
				JSON.stringify(this.$store.state.solelist)
			);
			sessionStorage.setItem("qpUobj", JSON.stringify(this.$store.state.uobj));

			let Logistics = this.$router.resolve({
				path: "/SalesCustomer",
				query: {
					mark: mark,
				},
			});
			this.$baseAPI.requestFullScreen(Logistics);
		},
		querycusList() {
			this.tableData = []
			if (this.cusQueryNameFD == '全部') {
				this.cusQueryNameFD = '';
			}
			var url = "/orm/ormtb493/ormtb493ListAdmin"

			var postData = {
				// ORMTB400ID: this.userobj.ormtb400.ORMTB400ID,
				ORMTBSL410ID: this.senderId, //客户ID
				ORMTB410CA01: this.cusQueryNameFD, //客户名称
				ORMTB493CA16: this.cusQueryiphone, //手机号
				page: this.page,
				limit: this.pagesize
			}
			var loading = this.$loading({
				lock: true,
				text: '请求中...',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.5)'
			});
			this.axios.post(url, postData).then(res => {
				// console.log(res)
				if (res.data.code == 200) {
					this.tableData = res.data.data;
					this.count = res.data.count;
					this.tableData.forEach((item) => {
						this.xsZsrcList.push(item.ORMTB450CA01);
						this.xsFsrcList.push(item.ORMTB450CA02);
						this.jszsrcList.push(item.ORMTB450CA08);
					});
				} else {
					this.$message({
						message: res.data.message,
						type: 'error'
					});
				}
				setTimeout(() => {
					loading.close()
				}, 300)

			}).catch(() => {
				loading.close()
			})
		},
		handleSizeChange(val) {
			this.pagesize = val;
			this.page = 1;
			this.querycusList();
		},
		handleCurrentChange(val) {
			this.page = val;
			this.querycusList();
		},
		CZrecordClick(row) {
			// console.log(row)
			this.preferentialRecord = true
			var str = JSON.stringify(row)
			this.cusUpdateObj = JSON.parse(str)
			this.CZrecordQuery()
		},
		CZrecordQuery() {
			this.CZRecordsDetails = []
			// this.CZRecordsCount =0
			var url = "/orm/ormtb411/selectPageList"
			var loading = this.$loading({
				lock: true,
				text: '请求中...',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.5)'
			});
			var postData = {
				ORMTB410ID: this.cusUpdateObj.ORMTB410ID,
				page: this.CZRecordsPage,
				limit: this.CZRecordsPageLimit
			}
			this.axios.post(url, postData).then(res => {
				// console.log(res)
				if (res.data.code == 200) {
					this.CZRecordsDetails = res.data.data;
					this.CZRecordsCount = res.data.count;
				} else {
					this.$message({
						message: res.data.message,
						type: 'error'
					});
				}
				setTimeout(() => {
					loading.close()
				}, 300)
			}).catch(() => {
				loading.close()
			})
		},
		offerDetailsClick(row) {
			this.offerDetails = true
			this.offerDetailsTab = []
			var url = "/orm/ormtb412/selectList"
			var loading = this.$loading({
				lock: true,
				text: '请求中...',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.5)'
			});
			var postData = {
				ORMTB411ID: row.ORMTB411ID,
				SETTB206CD01: this.userobj.pertb005.pertb005cd01,
			}
			this.axios.post(url, postData).then(res => {
				// console.log(res)
				if (res.data.code == 200) {
					this.offerDetailsTab = res.data.data;
				} else {
					this.$message({
						message: res.data.message,
						type: 'error'
					});
				}
				setTimeout(() => {
					loading.close()
				}, 300)
			}).catch(() => {
				loading.close()
			})
		},
		deductionRecordClick(row) {
			this.deductionRecordtable = []
			// this.deductionRecordCount=0
			var url = "/orm/ormtb413/selectPageList"
			var loading = this.$loading({
				lock: true,
				text: '请求中...',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.5)'
			});
			this.ORMTB411ID = row.ORMTB411ID
			var postData = {
				ORMTB411ID: this.ORMTB411ID,
				page: this.deductionRecordPage,
				limit: this.deductionRecordLimit
			}
			this.axios.post(url, postData).then(res => {
				// console.log(res)
				if (res.data.code == 200) {
					this.deductionRecordtable = res.data.data;
					this.deductionRecordCount = res.data.count
					this.deductionRecordtable.forEach(item => {
						if (item.ORMTB413CA02 == 'KK') {
							item.ORMTB413CA02Text = "扣款"
						} else if (item.ORMTB413CA02 == 'TK') {
							item.ORMTB413CA02Text = "退款"
						}
					})
				} else {
					this.$message({
						message: res.data.message,
						type: 'error'
					});
				}
				setTimeout(() => {
					loading.close()
				}, 300)
			}).catch(() => {
				loading.close()
			})
		},
		deductionRecordSizeChange(val) {
			this.deductionRecordLimit = val;
			this.deductionRecordPage = 1;
			this.deductionRecordClick();
		},
		deductionRecordCurrentChange(val) {
			this.deductionRecordPage = val;
			this.deductionRecordClick();
		},
		queryWayTypeQuery() {
			this.tableDataDetails = []
			// this.detailsCount=0
			var url = "/set/settb206/selectPageList"
			var loading = this.$loading({
				lock: true,
				text: '请求中...',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.5)'
			});
			var postData = {
				SETTB206CD01: this.userobj.ormtb400.ORMTB400CA03,
				SETTB205ID: '01',
				page: this.currentPage1,
				limit: this.detailsPageLimit
			}
			this.axios.post(url, postData).then(res => {
				// console.log(res)
				if (res.data.code == 200) {
					this.tableDataDetails = res.data.data;
					this.detailsCount = res.data.count
				} else {
					this.$message({
						message: res.data.message,
						type: 'error'
					});
				}
				setTimeout(() => {
					loading.close()
				}, 300)
			}).catch(() => {
				loading.close()
			})
		},
		handleSizeChange1(val) {
			this.detailsPageLimit = val;
			this.currentPage1 = 1;
			this.deductionRecordClick();
		},
		handleCurrentChange1(val) {
			this.currentPage1 = val;
			this.deductionRecordClick();
		},
		saleWaterDetailsclose() {

		},
		CustomerfillingDigClose() {

		},
		cusInsertClose() {
			this.cusInsertObj = {
				ORMTB400ID: '',
				ORMTB410CA00: '',
				ORMTB410CA01: '',
				ORMTB410CA02: '',
				ORMTB410CA06: ''
			}
		},

		upCusClose() {
			this.cusUpdateObj = {
				ORMTB400ID: '',
				ORMTB410CA00: '',
				ORMTB410CA01: '',
				ORMTB410CA02: '',
				ORMTB410CA06: ''
			}
			this.CZmoney = ''
			this.wayTypeValue = 'CW'
			this.amountCapitalText = ''
		},
		CZTypeQuery() {
			this.RechargetypeOptions = []
			var url = "/orm/ormtb411/selectCzType/" + this.userobj.ormtb400.ORMTB400CA03
			var loading = this.$loading({
				lock: true,
				text: '请求中...',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.5)'
			});
			this.axios.get(url).then(res => {
				// console.log(res)
				if (res.data.code == 200) {
					this.RechargetypeOptions = res.data.data
				} else {
					this.$message({
						message: res.data.message,
						type: 'error'
					});
				}
				setTimeout(() => {
					loading.close()
				}, 300)
			}).catch(() => {
				loading.close()
			})
		},
		czClick(row) { //点击充值
			this.CustomerfillingDig = true
			var str = JSON.stringify(row)
			this.cusUpdateObj = JSON.parse(str)
			this.CZTypeQuery()
		},
		CZserve() {
			if (this.RechargetypeValue == '') return this.$message.error('请选择充值类型')
			if (this.wayTypeValue == '') return this.$message.error('请选择变动方式')
			if (this.CZmoney <= 0) return this.$message.error('请输入充值金额')
			var url = "/orm/ormtb411/cz"
			var loading = this.$loading({
				lock: true,
				text: '请求中...',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.5)'
			});
			var postData = {
				ORMTB410ID: this.cusUpdateObj.ORMTB410ID,
				ORMTB420CA01: this.wayTypeValue,
				ORMTB420CA02: this.CZmoney,
				ORMTB411CA04: this.RechargetypeValue
			}
			this.axios.post(url, postData).then(res => {
				// console.log(res)
				if (res.data.code == 200) {
					this.$message.success('充值成功')
					this.querycusList()
					this.CustomerfillingDig = false
				} else {
					this.$message({
						message: res.data.message,
						type: 'error'
					});
				}
				setTimeout(() => {
					loading.close()
				}, 300)
			}).catch(() => {
				loading.close()
			})
		},
		HCclick(row) { //点击红值
			var str = JSON.stringify(row)
			this.cusUpdateObj = JSON.parse(str)
			this.HCshow = true
		},

		HCserve() {
			if (!this.HCmoney) return this.$message.error('请输入红冲金额');
			if (!this.HCremark) return this.$message.error('请输入备注');
			// if (this.HCmoney > this.cusUpdateObj.ORMTB410CA03) return this.$message.error('红冲金额不可大于余额');
			var url = "/orm/ormtb411/hc"
			var loading = this.$loading({
				lock: true,
				text: '请求中...',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.5)'
			});
			var postData = {
				ORMTB410ID: this.cusUpdateObj.ORMTB410ID,
				ORMTB420CA02: this.HCmoney,
				ORMTB420CA08: this.HCremark
			}
			this.axios.post(url, postData).then(res => {
				// console.log(res)
				if (res.data.code == 200) {
					this.$message.success(`红冲成功`)
					this.HCshow = false
					this.querycusList()
					this.HCremark = ''
					this.HCmoney = ''
				} else {
					this.$message({
						message: res.data.message,
						type: 'error'
					});
				}
				setTimeout(() => {
					loading.close()
				}, 300)
			}).catch(() => {
				loading.close()
			})
		},
		upuserClick(row) {
			if (this.preferentialType == 1) {
				this.customerManagementQuery()
			}
			this.cusUpdateShow = true
			var str = JSON.stringify(row)
			this.cusUpdateObj = JSON.parse(str)
		},
		cusADD() {
			if (this.preferentialType == 1) {
				this.customerManagementQuery()
			}
			this.cusInsertShow = true
		},
		cusUpdateServe() {
			if (this.cusUpdateObj.ORMTB410CA00.trim().length == 0) return this.$message.error('请输入客户名称')
			var reQ = /^1[3-9][0-9]{9}$/;
			if (!reQ.test(this.cusUpdateObj.ORMTB410CA02)) return this.$message.error('请输入有效手机号')
			if (this.preferentialType == 1) {
				if (this.cusUpdateObj.ORMTB410CA06.length == 0) {
					return this.$message.error('请选择客户等级')
				}
			}
			var url = "/orm/ormtb410/updateOrmtb410ById"
			var loading = this.$loading({
				lock: true,
				text: '请求中...',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.5)'
			});
			var postData = this.cusUpdateObj
			this.axios.post(url, postData).then(res => {
				// console.log(res)
				if (res.data.code == 200) {
					this.$message.success('修改成功')
					this.querycusList()
					this.cusUpdateShow = false
					this.cusUpdateObj = {
						ORMTB400ID: '',
						ORMTB410CA00: '',
						ORMTB410CA01: '',
						ORMTB410CA02: '',
						ORMTB410CA06: ''
					}
				} else {
					this.$message({
						message: res.data.message,
						type: 'error'
					});
				}
				setTimeout(() => {
					loading.close()
				}, 300)
			}).catch(() => {
				loading.close()
			})
		},
		rechargeTypeModify(row) {
			this.rechargeTypeModifyDig = true
			var str = JSON.stringify(row)
			this.rechargeTypeUpOBJ = JSON.parse(str)
		},
		disableCus(row, type) {
			var str = type == 1 ? '启用' : '禁用'
			this.$confirm(`此操作将${str}该条数据, 是否继续?`, '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				var url = "/orm/ormtb410/updataCzType"
				var loading = this.$loading({
					lock: true,
					text: '请求中...',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.5)'
				});
				// console.log(this.userobj)
				var postData = {
					SETTB206CA01: '',
					SETTB206ID: row.SETTB206ID,
					SETTB206CA02: type,
				}
				this.axios.post(url, postData).then(res => {
					// console.log(res)
					if (res.data.code == 200) {
						this.$message.success(`${str}成功`)
						this.queryWayTypeQuery()
					} else {
						this.$message({
							message: res.data.message,
							type: 'error'
						});
					}
					setTimeout(() => {
						loading.close()
					}, 300)
				}).catch(() => {
					loading.close()
				})
			})
		},
		rechargeTypeAdd() {
			this.rechargeTypeDig = true
		},
		rechargeTypeModifyClose() {
			this.rechargeTypeUpOBJ = {
				SETTB206CA01: ''
			}
		},
		querypreferentialCode() {
			var url = "/set/settb206/selectSETTB206List "
			var loading = this.$loading({
				lock: true,
				text: '请求中...',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.5)'
			});
			var postData = {
				"SETTB205ID": "02", //默认02
				"SETTB206CA00": "0202", //代码值默认0202
				"SETTB206CD01": this.userobj.ormtb400.ORMTB400CA03 //一级客户代码
			}
			this.axios.post(url, postData).then(res => {
				// console.log(res)
				if (res.data.code == 200) {
					this.preferentialType = res.data.data[0].SETTB206CA02
					// 	loading.close()
				} else {
					this.$message({
						message: res.data.message,
						type: 'error'
					});
				}
				setTimeout(() => {
					loading.close()
				}, 300)
			}).catch(() => {
				loading.close()
			})
		},
		customerManagementQuery() {
			this.customerManagementList = []
			var url = "/set/settb206/selectPerson/" + this.userobj.ormtb400.ORMTB400CA03
			var loading = this.$loading({
				lock: true,
				text: '请求中...',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.5)'
			});
			this.axios.get(url).then(res => {
				// console.log(res)
				if (res.data.code == 200) {
					this.customerManagementList = res.data.data
				} else {
					this.$message({
						message: res.data.message,
						type: 'error'
					});
				}
				setTimeout(() => {
					loading.close()
				}, 300)
			}).catch(() => {
				loading.close()
			})
		},
		customerManagementAddServe() {
			if (this.customerManagementAddName.trim().length == 0) return this.$message.error('请输入名称')
			var url = "/set/settb206/insertVIP "
			var loading = this.$loading({
				lock: true,
				text: '请求中...',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.5)'
			});
			// console.log(this.userobj)
			var postData = {
				SETTB206CA01: this.customerManagementAddName,
				SETTB206CD01: this.userobj.ormtb400.ORMTB400CA03,
				ORMTB400ID: this.userobj.ormtb400.ORMTB400ID
			}
			this.axios.post(url, postData).then(res => {
				// console.log(res)
				if (res.data.code == 200) {
					this.$message.success('新增成功')
					this.customerManagementQuery()
					this.customerManagementAdd = false
				} else {
					this.$message({
						message: res.data.message,
						type: 'error'
					});
				}
				setTimeout(() => {
					loading.close()
				}, 300)
			}).catch(() => {
				loading.close()
			})
		},
		cusUpdataClick(row) {
			this.customerManagemenUPObj = row
			this.customerManagemenUPObj.oldname = row.SETTB206CA01
			this.customerManagementUpdate = true
		},
		customerManagementUpdateServe() {
			if (this.customerManagemenUPObj.oldname == this.customerManagemenUPObj.SETTB206CA01)
				return this.$message
					.error('请修改名称')
			if (this.customerManagemenUPObj.SETTB206CA01.trim().length == 0) return this.$message.error(
				'请输入名称')
			var url = "/set/settb206/updateVIP"
			var loading = this.$loading({
				lock: true,
				text: '请求中...',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.5)'
			});
			var postData = {
				SETTB206CA01: this.customerManagemenUPObj.SETTB206CA01,
				SETTB206ID: this.customerManagemenUPObj.SETTB206ID,
			}
			this.axios.post(url, postData).then(res => {
				// console.log(res)
				if (res.data.code == 200) {
					this.$message.success('修改成功')
					this.customerManagementQuery()
					this.customerManagementUpdate = false
				} else {
					this.$message({
						message: res.data.message,
						type: 'error'
					});
				}
				setTimeout(() => {
					loading.close()
				}, 300)
			}).catch(() => {
				loading.close()
			})
		},
		rechaTypePreser() {
			if (this.rechargeTypeName.trim().length == 0) return this.$message.error('请输入名称')
			var url = "/orm/ormtb410/addCzType"
			var loading = this.$loading({
				lock: true,
				text: '请求中...',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.5)'
			});
			// console.log(this.userobj)
			var postData = {
				SETTB206CA01: this.rechargeTypeName,
				SETTB206CD01: this.userobj.ormtb400.ORMTB400CA03
			}
			this.axios.post(url, postData).then(res => {
				// console.log(res)
				if (res.data.code == 200) {
					this.$message.success('新增成功')
					this.queryWayTypeQuery()
					this.rechargeTypeDig = false
				} else {
					this.$message({
						message: res.data.message,
						type: 'error'
					});
				}
				setTimeout(() => {
					loading.close()
				}, 300)
			}).catch(() => {
				loading.close()
			})
		},
		rechaTypePreserModify() {
			if (this.rechargeTypeUpOBJ.SETTB206CA01.trim().length == 0) return this.$message.error('请输入名称')
			var url = "/orm/ormtb410/updataCzType"
			var loading = this.$loading({
				lock: true,
				text: '请求中...',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.5)'
			});
			// console.log(this.userobj)
			var postData = {
				SETTB206CA01: this.rechargeTypeUpOBJ.SETTB206CA01,
				SETTB206ID: this.rechargeTypeUpOBJ.SETTB206ID,
				SETTB206CA02: this.rechargeTypeUpOBJ.SETTB206CA02,
				SETTB206CD01: this.userobj.ormtb400.ORMTB400CA03
			}
			this.axios.post(url, postData).then(res => {
				// console.log(res)
				if (res.data.code == 200) {
					this.$message.success('修改成功')
					this.queryWayTypeQuery()
					this.rechargeTypeModifyDig = false
				} else {
					this.$message({
						message: res.data.message,
						type: 'error'
					});
				}
				setTimeout(() => {
					loading.close()
				}, 300)
			}).catch(() => {
				loading.close()
			})
		},
		DetailsWaterClick(item) {
			// console.log(item)
			if (!item.ORMTB440CA00) {
				this.$message({
					message: '未查询到订单',
					type: 'error'
				});
				return
			}
			this.DetailsWater = true
			this.deductionRecordDetileQuery(item)
		},
		deductionRecordDetileQuery(row) {
			this.deductionRecordObj = ''
			this.DetailsWatersrcList = []
			this.DetailsWaterurl = ''
			var url = "/orm/ormtb440/selectDetails"
			var loading = this.$loading({
				lock: true,
				text: '请求中...',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.5)'
			});
			// console.log(this.userobj)
			var postData = {
				ORMTB440ID: row.ORMTB413CA03,
			}
			this.axios.post(url, postData).then(res => {
				// console.log(res)
				if (res.data.code == 200) {
					this.deductionRecordObj = res.data.data
					this.DetailsWatersrcList = [this.deductionRecordObj.ORMTB440CE01]
					this.DetailsWaterurl = this.deductionRecordObj.ORMTB440CE01
				} else {
					this.$message({
						message: res.data.message,
						type: 'error'
					});
				}
				setTimeout(() => {
					loading.close()
				}, 300)
			}).catch(() => {
				loading.close()
			})
		},
		CZRecordsSizeChange(val) {
			this.pagesize = val;
			this.page = 1;
			this.CZrecordQuery();
		},
		CZRecordsCurrentChange(val) {
			this.page = val;
			this.CZrecordQuery();
		},

		HCMoneyInput() {
			this.HCmoney = this.HCmoney.replace(/[^\d.]/g, ""); //清除“数字”和“.”以外的字符
			this.HCmoney = this.HCmoney.replace(/^\./g, ""); //验证第一个字符是数字
			this.HCmoney = this.HCmoney.replace(/\.{2,}/g, "."); //只保留第一个. 清除多余的
			this.HCmoney = this.HCmoney.replace(".", "$#$").replace(/\./g, "").replace("$#$", ".");
			this.HCmoney = this.HCmoney.replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3'); //只能输入两个小数
			if (this.HCmoney.indexOf(".") < 0 && this.HCmoney !=
				"") { //以上已经过滤，此处控制的是如果没有小数点，首位不能为类似于 01、02的金额
				this.HCmoney = parseFloat(this.HCmoney);
			}
			this.HCmoney = this.HCmoney > 10000000 ? 10000000 : this.HCmoney
			this.$refs.HCmoney.value = this.HCmoney
			this.HCamountCapitalText = this.priceChange(this.HCmoney)
		},
		HCMoneyChange() {
			var index = String(this.HCmoney).indexOf('.')
			if (index == -1) return
			var numArr = this.HCmoney.split('.')
			if (numArr[1].length == 0) {
				this.$refs.HCmoney.value = numArr[0]
				this.HCmoney = numArr[0]
			} else {
				this.$refs.HCmoney.value = numArr[0] + '.' + numArr[1]
				this.HCmoney = numArr[0] + '.' + numArr[1]
			}
		},
		topMoneyInput() { //充值金额实时校验
			this.CZmoney = this.CZmoney.replace(/[^\d.]/g, ""); //清除“数字”和“.”以外的字符
			this.CZmoney = this.CZmoney.replace(/^\./g, ""); //验证第一个字符是数字
			this.CZmoney = this.CZmoney.replace(/\.{2,}/g, "."); //只保留第一个. 清除多余的
			this.CZmoney = this.CZmoney.replace(".", "$#$").replace(/\./g, "").replace("$#$", ".");
			this.CZmoney = this.CZmoney.replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3'); //只能输入两个小数
			if (this.CZmoney.indexOf(".") < 0 && this.CZmoney !=
				"") { //以上已经过滤，此处控制的是如果没有小数点，首位不能为类似于 01、02的金额
				this.CZmoney = parseFloat(this.CZmoney);
			}
			this.CZmoney = this.CZmoney > 10000000 ? 10000000 : this.CZmoney
			this.$refs.topMoney.value = this.CZmoney
			this.amountCapitalText = this.priceChange(this.CZmoney)
		},
		priceChange(number) {
			var ret = "";
			if (number != "" && number != null && number != "0") {
				var unit = "仟佰拾亿仟佰拾万仟佰拾元角分",
					str = "";
				number += "00";
				var point = number.indexOf(".");
				if (point >= 0) {
					number = number.substring(0, point) + number.substr(point + 1, 2);
				}
				unit = unit.substr(unit.length - number.length);
				for (var i = 0; i < number.length; i++) {
					str += "零壹贰叁肆伍陆柒捌玖".charAt(number.charAt(i)) + unit.charAt(i);
				}
				ret =
					str
						.replace(/零(仟|佰|拾|角)/g, "零")
						.replace(/(零)+/g, "零")
						.replace(/零(万|亿|元)/g, "$1")
						.replace(/(亿)万|(拾)/g, "$1$2")
						.replace(/^元零?|零分/g, "")
						.replace(/元$/g, "元");
			}
			return ret;
		},
		topMoneyChange() { //充值金额失去焦点数据处理
			var index = String(this.CZmoney).indexOf('.')
			if (index == -1) return
			var numArr = this.CZmoney.split('.')
			if (numArr[1].length == 0) {
				this.$refs.topMoney.value = numArr[0]
				this.CZmoney = numArr[0]
			} else {
				this.$refs.topMoney.value = numArr[0] + '.' + numArr[1]
				this.CZmoney = numArr[0] + '.' + numArr[1]
			}
		},
	}
};
</script>

<style scoped>
.carDialogTitle {
	font-weight: bold;
	line-height: 60px;
	color: rgb(0, 163, 255);
}

.customerManagementPC {
	background-color: #f3f3f3;
}

.DWD-li {
	display: flex;
	height: 35px;
	line-height: 35px;
	box-sizing: border-box;
	border: 1px solid #999;
	font-size: 16px;
	color: #333;
}

.DWD-li>div {
	padding: 0 5px;
	height: 34px;
	overflow: hidden;
	box-sizing: border-box;
}

.DWD-li-title {
	width: 150px;
	text-align: center;
	border-right: 1px solid #999;
	background-color: rgba(0, 163, 255, .1);
}

.DWD-li+.DWD-li {
	border-top: none;
}

.DWD-table {
	display: flex;
}

.DWD-table-left-flex {
	flex: 1;
}

.DWD-table>div>div {
	padding: 0 5px;
	height: 35px;
	line-height: 35px;
	overflow: hidden;
	text-align: center;
	border-right: 1px solid #999;
	border-bottom: 1px solid #999;
	box-sizing: border-box;
}

.DWD-table>div>div:first-child {
	background-color: rgba(0, 163, 255, .1);
}

.DWD-table-left-title>div {
	width: 101px;
	text-align: center;
	background-color: rgba(0, 163, 255, .1);
}

.DWD-table .DWD-table-left-title>div {
	padding: 0 5px;
	height: 35px;
	line-height: 35px;
	overflow: hidden;
	box-sizing: border-box;
	border-left: 1px solid #999;
	border-bottom: 1px solid #999;
}

.DetailsWater-img {
	margin-top: 30px;
}

.DetailsWater-img-text {
	display: inline-block;
	width: 101px;
	text-align: center;
	vertical-align: top;
}

.customerManagementPC-select .public_oparetionBlock_Menu:first-child {
	margin-left: 0;
}

.customerManagementPC-btn {
	text-align: left;
	margin-bottom: 20px;
}

.customerManagementPC-btn i {
	margin-right: 10px;
}

.customerManagementPC-table {
	padding: 30px 20px 0;
}

.customerManagementPC-table-btn i {
	font-size: 12px;
	margin-right: 5px;
}

.customerManagementPC-add-customer {
	padding-left: 20px;
}

.customerManagementPC-add-customer-li {
	display: flex;
	text-align: center;
	font-size: 16px;
	height: 42px;
	line-height: 42px;
}

.customerManagementPC-add-customer-li>div {
	border: 1px solid #cdcdcd;
	border-top: none;
}

.customerManagementPC-add-customer-li:first-child>div {
	border-top: 1px solid #cdcdcd;
}

.customerManagementPC-add-customer-li>div:first-child {
	border-right: none;
}

.customerManagementPC-add-customer-li>div:last-child {
	border: none;
	color: #ff4d35;
}

.customerManagementPC-add-customer-li-name {
	flex: 1;
}

.customerManagementPC-add-customer-li-ipt {
	flex: 1;
	box-sizing: border-box;
}

.customerManagementPC-add-customer-li-ipt input {
	border: none;
	outline: none;
	width: 100%;
	height: 37px;
	box-sizing: border-box;
	vertical-align: top;
	padding-left: 5px;
	text-align: center;
	font-size: 16px;
}

.customerManagementPC-add-customer-li-type {
	flex: 0.3;
}

.customerManagementPC-add-customer-btn {
	text-align: center;
	margin: 30px 0 20px 0;
}

.public-chech-details-table {
	margin-top: 20px;
	max-height: 500px;
	overflow-y: auto;
}

.public-chech-details-table-no-text {
	line-height: 80px;
	text-align: center;
	border-bottom: 1px solid #cdcdcd;
}

.customerManagementPC-page {
	margin-top: 20px;
	text-align: right;
}

.CustomerfillingDig-priceNumtext {
	font-weight: 500;
	font-size: 18px;
	line-height: 40px;
	padding: 20px 0 20px 10px;
	color: #333;
}

.CustomerfillingDig-priceNumtext span {
	color: rgba(175, 181, 4, 1.0);
	margin-left: 10px;
	font-size: 20px;
}

.fontBlue {
	color: rgba(25, 159, 255, 1) !important;
}

.billOperationRecord {
	background-color: #f3f3f3;
}

.billOperationRecord-border {

	/* border-top: 2px solid rgba(205,205,205,.4); */
	border-top: none;
	box-sizing: border-box;
	margin-right: 40px;
}

.billOperationRecord th,
.billOperationRecord td {
	text-align: center;
}

.customerRecharge-table {
	box-sizing: border-box;
}

.CustomertopUpDig-content-table-btn>.public_saleWater_lieSet {
	border-color: rgba(254, 172, 0, 1) !important;
}

.CustomerfillingDig-tab {
	padding-left: 20px;
}

.CustomerfillingDig-tab-li,
.rechargeType-tab-li {
	display: flex;
	height: 50px;
	line-height: 50px;
	text-align: center;
	font-size: 16px;
	color: #333;
	vertical-align: top;
}

.CustomerfillingDig-tab-li>div {
	border: 1px solid #CDCDCD;
	border-top: none;
}

.CustomerfillingDig-tab-li>div:first-child {
	border-right: none;
}

.CustomerfillingDig-tab-li:first-child>div {
	border-top: 1px solid #CDCDCD;
}

.CustomerfillingDig-tab-li>div:last-child,
.rechargeType-tab-li>div:last-child {
	border: none;
	color: #FF4D35;
}

.CustomerfillingDig-tab-li-text {
	flex: .8;
	background: rgba(240, 252, 255, 1);
}

.CustomerfillingDig-tab-li-ipt {
	flex: .8;
}

.rechargeType-tab-li-text {
	flex: .35;
}

.rechargeType-tab-li-ipt {
	flex: .7;
}

.CustomerfillingDig-tab-li-ipt input,
.rechargeType-tab-li-ipt input {
	height: 46px;
	width: 100%;

	text-align: center;

	box-sizing: border-box;
	font-size: 16px;
	color: #333;
}

.CustomerfillingDig-tab-li-ipt input {
	outline: none;
	border: none;
	vertical-align: top;
}

.rechargeType-tab-li-ipt input {
	/* border-radius: 8px; */
	/* outline: none; */
}

.CustomerfillingDig-tab-li-b,
.rechargeType-tab-li-b {
	flex: .3;
}

.CustomerfillingDig-tab-btn {
	text-align: center;
	margin-top: 30px;
}

.rechargeType-tab-btn {
	margin-top: 80px !important;
}

.billOperationRecord-page {
	padding-right: 40px;
	text-align: right;
	margin-top: 20px;
	padding-bottom: 20px;
}

.salesWatersStatisticsPC-saleWaterDetails-btn {
	margin-bottom: 20px;
}

.salesWatersStatisticsPC-saleWaterDetails-btn i {
	margin-right: 10px;
}

.el-dropdown-link {
	cursor: pointer;
}

.el-table--scrollable-y .el-table__body-wrapper {
	overflow: auto;
}

.public_tableColumn .el-table__body-wrapper {
	overflow: auto !important;
}

.public_icon_width {
	width: 80px;
}

.public_saleWater_chaxun {
	border-radius: 4px !important;
	margin-left: 20px !important;
}

.public_saleWater_fabu {
	background-color: #e78608 !important;
	border: none;
}

.pulbic_oparetionBlock {
	display: flex;
	justify-content: space-between;
}
</style>
